const rolesReducer = (state = null, action) => {
    switch (action.type) {
        case "GET_ROLES":
            return action.payload;
        default:
            return state;
    }
};
export default rolesReducer;
